module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-screen2-ac9eeb31663aa83794e35f9e6f42ce6b.png";